import { Http,HttpCase,HttpCaseFlowInitiation,HttpEmpBiog,HttpH1BForms,HttpUpload,HttpFormType  } from "../Http";
 
export class VisaCareCaseAPI {

    public static  caseflowCreateEmptyCase(input: any){
          var url = "caseflow/createEmptyCase/";
 
if(input.formName.common_value==="H1B Public Access File Only" || input.formName.common_value==="Public Access File Only" || input.formName.common_value==="H1B LCA Only"  ){
  url ="caseflow/createEmptyCaseWithoutPayment/";
}
   
          
          var obj=JSON.stringify(input);
 
          if (input ==="") {
            return { data: [] };
          }
          
          const resultMethod = HttpCase.axios().post(url, obj,
            {
              headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "*",
                "Access-Control-Allow-Headers": "*"
              }
            })
            .then(res => {
               
              return res;

            }).catch((e: any) => {
        
              return e.response;
            });
          return resultMethod; 
      }

      public static  caseflowUpdateCase(input: any){
        var url = "caseflow/updateCase/";
        var obj=JSON.stringify(input);
       
        if (input ==="") {
          return { data: [] };
        }
        const resultMethod = HttpCase.axios().put(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
            
            return res;
          }).catch((e: any) => {
   
            return e.response;
          });
        return resultMethod;
    }
      
    public static   caseflowInitiationCreate  (input: any){
      var url = "caseflowinitiation/create/";
      var obj=JSON.stringify(input);
    
      if (input ==="") {
        return { data: [] };
      }
      const resultMethod = HttpCaseFlowInitiation.axios().post(url, obj,
        {
          headers: {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "*",
            "Access-Control-Allow-Headers": "*"
          }
        })
        .then(res => {
          
          return res;
        }).catch((e: any) => {
          
          return e.response;
        });
      return resultMethod;
  }
 
  public static  caseflowInitiationUpdate(input: any){
    var url = "caseflowinitiation/update/";
    var obj=JSON.stringify(input);
    if (input ==="") {
      return { data: [] };
    }

    const resultMethod = HttpCaseFlowInitiation.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
       
        return res;
      }).catch((e: any) => {
       
        return e.response;
      });
    return resultMethod;
}
 
public static   workflowCreate  (input: any){
  var url = "workflow/create";
  var obj=JSON.stringify(input);
  if (input ==="") {
    return { data: [] };
  }
  const resultMethod = Http.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
    
      return res;
    }).catch((e: any) => {
 
      return e.response;
    });
  return resultMethod;
}

public static  workflowUpdateWorkflows(input: any){
var url = "workflow/updateWorkflows";
var obj=JSON.stringify(input);
if (input ==="") {
  return { data: [] };
}
const resultMethod = Http.axios().put(url, obj,
  {
    headers: {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "*",
      "Access-Control-Allow-Headers": "*"
    }
  })
  .then(res => {
  
    return res;
  }).catch((e: any) => {
  
    return e.response;
  });
return resultMethod;
}
 
public static   employeeBiographicsCreate  (input: any){
  var url = "employeebiographics/create";
  var obj=JSON.stringify(input);
  
  if (input ==="") {
    return { data: [] };
  }
  const resultMethod = HttpEmpBiog.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
      
      return res;
    }).catch((e: any) => {
 
      return e.response;
    });
  return resultMethod;
}

public static  employeeBiographicsUpdate(input: any){
var url = "employeebiographics/update";
var obj=JSON.stringify(input);
if (input ==="") {
  return { data: [] };
}
const resultMethod = HttpEmpBiog.axios().put(url, obj,
  {
    headers: {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "*",
      "Access-Control-Allow-Headers": "*"
    }
  })
  .then(res => {
  
    return res;
  }).catch((e: any) => {
 
    return e.response;
  });
return resultMethod;
}

 
public static   h1bformsCreate  (input: any){
  var url = "h1bforms/create";
  var obj=JSON.stringify(input);   
  if (input ==="") {
    return { data: [] };
  }
  const resultMethod = HttpH1BForms.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
     
      return res;
    }).catch((e: any) => {
    
      return e.response;
    });
  return resultMethod;
}

public static  h1bformsUpdate(input: any){
var url = "h1bforms/update";
var obj=JSON.stringify(input);  
 
if (input ==="") {
  return { data: [] };
}
 
const resultMethod = HttpH1BForms.axios().put(url, obj,
  {
    headers: {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "*",
      "Access-Control-Allow-Headers": "*"
    }
  })
  .then(res => {
   
    return res;
  }).catch((e: any) => {
 
    return e.response;
  });
return resultMethod;
}


public static  h1bformsPdfSubmit(input: any){
  var url = "caseflow/submitPdfGeneration/"+input.input ;
 
  if (input ==="") {
    return { data: [] };
  }

  const resultMethod = HttpCase.axios().post(url, input,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
   /*   var filename = res.data.outputPdfFilename;
      filename = filename.substring(filename.lastIndexOf('/') + 1);
      var obj = {
          "companyCode": res.data.companyCode,
          "caseId": res.data.caseId
      };
      var urlName = 'fileupload/getFile/' + filename;
       
      HttpUpload.axios().get(urlName , {params: obj, responseType: 'blob' }
      ).then(response => response.data)
          .then(blob => {

              var url = window.URL.createObjectURL(blob);
              var a = document.createElement('a');
              a.href = url;
              a.download = filename;
              a.click();
              a.remove();
              
          }) */
          return res;
    }).catch((e: any) => {
      
      return e.response;
    });
  
  return resultMethod;
  }

public static  getAllCaseflows(input: any){
  var url = "caseflow/getAllCaseflows/" + input.input;
 if(input.inputparam!=null){
     url = "caseflow/getAllCaseflows/" + input.input+"?userName="+input.inputparam+"&calculatePercentageFields=true";  
 }else{
  url = url + "?calculatePercentageFields=true";
 }
    if (input ==="") {
      return { data: [] };
    }

    const resultMethod = HttpCase.axios()
      .get(url,  {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => { 
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    
    return resultMethod;  
}
public static  getAllCaseflow(input: any){
 
  //var url = "caseflow/getAllCaseflow/" + input.input;  
 
  var url = "caseflow/getCaseflow/" + input.input;  
  
   if (input ==="") {
     return { data: [] };
   }

   const resultMethod = HttpCase.axios()
     .get(url,  {
       headers: {
         "Content-Type": "application/json",
         "Access-Control-Allow-Origin": "*",
       }
     })
     .then(res => { 
       return res;
     })
     .catch((e: any) => {
       return e.response;
     });
   
   return resultMethod;  
}
public static  getCaseflowInitiationDetails(input: any){
 
  var url = "caseflowinitiation/getCaseflowInitiationDetails/" + input.input;  

   if (input ==="") {
     return { data: [] };
   }

   const resultMethod = HttpCaseFlowInitiation.axios()
     .get(url,  {
       headers: {
         "Content-Type": "application/json",
         "Access-Control-Allow-Origin": "*",
       }
     })
     .then(res => { 
       return res;
     })
     .catch((e: any) => {
       return e.response;
     });
   
   return resultMethod;  
}

public static  getEmployeeBiographicsDetails(input: any){
 
  var url = "employeebiographics/getEmployeeBiographicsDetails/" + input.input;  

   if (input ==="") {
     return { data: [] };
   }

   const resultMethod = HttpEmpBiog.axios()
     .get(url,  {
       headers: {
         "Content-Type": "application/json",
         "Access-Control-Allow-Origin": "*",
       }
     })
     .then(res => { 
      
       return res;
     })
     .catch((e: any) => {
       return e.response;
     });
   
   return resultMethod;  
}
public static  getH1bformsDetails(input: any){
 
  var url = "h1bforms/getH1BPetitionerDetails/" + input.input +"/"+ input.inputCaseType;  

   if (input ==="") {
     return { data: [] };
   }

   const resultMethod = HttpH1BForms.axios()
     .get(url,  {
       headers: {
         "Content-Type": "application/json",
         "Access-Control-Allow-Origin": "*",
       }
     })
     .then(res => { 
      
       return res;
     })
     .catch((e: any) => {
       return e.response;
     });
   
   return resultMethod;  
}

public static  getCaseDetails(input: any){
 
  var url = "caseflowinitiation/getCaseDetails/" + input.input ;  

   if (input ==="") {
     return { data: [] };
   }

   const resultMethod = HttpCaseFlowInitiation.axios()
     .get(url,  {
       headers: {
         "Content-Type": "application/json",
         "Access-Control-Allow-Origin": "*",
       }
     })
     .then(res => { 
      
       return res;
     })
     .catch((e: any) => {
       return e.response;
     });
   
   return resultMethod;  
}

public static   uploadFileCaseFlow  (input: any){
  var url = "fileupload/submit";
  var obj=JSON.stringify(input);   
  if (input ==="") {
    return { data: [] };
  }
  const resultMethod = HttpH1BForms.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
     
      return res;
    }).catch((e: any) => {
       
      return e.response;
    });
  return resultMethod;
}
public static   uploadFileH1BPetitioner  (input: any){
  var url = "fileupload/submit";
  var obj=JSON.stringify(input);  
  if (input ==="") {
    return { data: [] };
  }
  const resultMethod = HttpH1BForms.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
      
      return res;
    }).catch((e: any) => {
      
      return e.response;
    });
  return resultMethod;
}


public static  getAttorneyG28Details(input: any){
 
 
 var url = "caseflow/getAttorneyG28Informations/" + input.input ;  
 // var url = "caseflow/getAttorneyG28InformationsByAttorneyIdAndCaseId/" + input.input +"/"+ input.inputCaseId; 
   if (input ==="") {
     return { data: [] };
   }

   const resultMethod = HttpCase.axios()
     .get(url,  {
       headers: {
         "Content-Type": "application/json",
         "Access-Control-Allow-Origin": "*",
       }
     })
     .then(res => { 

       return res;
     })
     .catch((e: any) => {
       return e.response;
     });
   
   return resultMethod;  
}

public static   h1bg28formsCreate  (input: any){
  var url = "caseflow/createAttorneyG28Information";
 
 var obj=JSON.stringify(input); 

  if(input.g28Id!=null){
      url = "caseflow/updateAttorneyG28Information";
    
  }
 
  

  if (input ==="") {
    return { data: [] };
  }
  let resultMethod = null;
  if(input.g28Id!=null){
    resultMethod = HttpCase.axios().put(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
     
      return res;
    }).catch((e: any) => {
    
      return e.response;
    });
  }else{
    resultMethod = HttpCase.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
       
        return res;
      }).catch((e: any) => {
      
        return e.response;
      });
  }
  return resultMethod;
}

public static  generateG28Pdf(input: any){
 //VisaCareCaseAPI.h1bg28formsCreate(input.input.attorneyEligibilityInformationandNotice);
  
 var urlSave = "caseflow/createAttorneyG28Information";
 
 var obj=JSON.stringify(input.input.attorneyEligibilityInformationandNotice); 
 
  if(input.g28Id!=null){
    urlSave = "caseflow/updateAttorneyG28Information";
    
  }

  

  if (input ==="") {
    return { data: [] };
  }
 
  if(input.g28Id!=null){
   HttpCase.axios().put(urlSave, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
     
      return res;
    }).catch((e: any) => {
    
      return e.response;
    });
  }else{
   HttpCase.axios().post(urlSave, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
       
        return res;
      }).catch((e: any) => {
      
        return e.response;
      });
  }
 
   obj=JSON.stringify(input.input);   
 
  var url = "caseflow/g28PdfGeneration" ;  

 
  if (input ==="") {
    return { data: [] };
  }

   const resultMethod =HttpCase.axios().post(url,  obj ,{ headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Response-Type": "blob", 
  } } )
     .then(res => { 
     
      

      return res;
    })
     .catch((e: any) => {
       return e.response;
     });
   
   return resultMethod;  
}
 
public static  generateI907Pdf(input: any){
 
    var url = "caseflow/generateI907Form/"+input.input.caseId +"?companyId="+input.input.companyCode;
    var obj1 = {
         
      "caseId": input.input.caseId,
      "companyCode": input.input.companyCode
    };
 
    var fileUploadObj=   {
      "caseId": input.input.caseId,
      "companyAutoId": input.input.companyAutoId,
      "companyCode": input.input.companyCode,
      "employeeAccess": false,
      "enableEmail": false,
      "lawfirmCode": null,
      "lawfirmId": null,
      "uploadDocumentType": "I-907",
      "uploadFormDescription": "I-907",
      "uploadFormType": "I-907",
      "uploadFilePath":"",
      "uploadFileName":""
    }
   if (input ==="") { 
     return { data: [] };
   }
   
    const resultMethod =HttpCase.axios().post(url, { headers: {
     "Content-Type": "application/json",
     "Access-Control-Allow-Origin": "*",
     "Access-Control-Allow-Methods": "*",
     "Access-Control-Allow-Headers": "*" 
   } } )
      .then(res => {   
        var pdffilename = res.data;  
        fileUploadObj.uploadFilePath= pdffilename;    
        pdffilename = pdffilename.substring(pdffilename.lastIndexOf('/') + 1);  
        fileUploadObj.uploadFileName= pdffilename;             
        var urlName = 'fileupload/getFile/' + pdffilename; 
        HttpUpload.axios().get(urlName, { params: obj1, responseType: 'blob' }
        ).then(response => response.data)
          .then(blob => {
           
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;          
            a.download = pdffilename;          
            a.click();
            a.remove();          
          //  setTimeout(() => window.URL.revokeObjectURL(url), 100);
         })         
         HttpUpload.axios().post("/fileupload/createFileUpload",fileUploadObj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          }).then(res1 => {         
            alert("I-907 Form was created/updated  successfully based on the Changes.");
            window.location.reload();
          }).catch((e: any) => {        
           
          });
       
       return res;
     })
      .catch((e: any) => {
        return e.response;
      });
     
    return resultMethod;  
 }

 
public static  getI907FormDetails(input: any){
 
  var url = "h1bforms/getI907PremiumProcessingByCaseId/" + input.input ;  

   if (input ==="") {
     return { data: [] };
   }

   const resultMethod = HttpH1BForms.axios()
     .get(url,  {
       headers: {
         "Content-Type": "application/json",
         "Access-Control-Allow-Origin": "*",
       }
     })
     .then(res => { 

       return res;
     })
     .catch((e: any) => {
       return e.response;
     });
   
   return resultMethod;  
}
 

public static   createI907Form  (input: any){
  var url = "h1bforms/createI907PremiumProcessing";
  var obj=JSON.stringify(input);   
  if (input ==="") {
    return { data: [] };
  }
  const resultMethod = HttpH1BForms.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
     
      return res;
    }).catch((e: any) => {
    
      return e.response;
    });
  return resultMethod;
}

public static  updateI907Form(input: any){
var url = "h1bforms/updateI907PremiumProcessing";
 
var obj=JSON.stringify(input);   
if (input ==="") {
  return { data: [] };
}
const resultMethod = HttpH1BForms.axios().put(url, obj,
  {
    headers: {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "*",
      "Access-Control-Allow-Headers": "*"
    }
  })
  .then(res => {
   
    return res;
  }).catch((e: any) => {
 
    return e.response;
  });
return resultMethod;
}


public static  getAllCompanyProfileDetails(){
  var url = "vmCompanyProfileDetails/getAllVmCompanyProfileDetails";
 
  const resultMethod = HttpFormType.axios().get(url, 
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
     
      return res;
    }).catch((e: any) => {
   
      return e.response;
    });
  return resultMethod;
  }


  public static  getCaseDetailsByPetitionApproved(input: any){

    var url = "";
    if(input.inputValue === "RFE"){
      if(input.input !== null){
        url = "caseflowinitiation/getCaseDetailsByRfeRespondedOn?calculatePercentageFields=true&companyId="+input.input;
      }else if(input.param !== null){
        url = "caseflowinitiation/getCaseDetailsByRfeRespondedOn?calculatePercentageFields=true&filingUserName="+input.inputParam;
      }
      else if(input.input !== null && input.param !== null){
        url = "caseflowinitiation/getCaseDetailsByRfeRespondedOn?calculatePercentageFields=true&companyId="+input.input+"&filingUserName="+input.inputParam;
      }else if(input.input !== null && input.param !== null && input.lawfirmId !== null){
        url = "caseflowinitiation/getCaseDetailsByRfeRespondedOn?calculatePercentageFields=true&companyId="+input.input+"&filingUserName="+input.inputParam+"&lawfirmId="+input.inputParamlawfirmId;  
      }
      
    }     
   else if(input.inputValue === "Cases"){   
    if(input.inputParam !== null){
       url = "/caseflow/getAllCaseflows/"+input.input+"?calculatePercentageFields=true&userName="+input.inputParam;
    }  else{
      url = "/caseflow/getAllCaseflows/"+input.input+"?calculatePercentageFields=true";
    } 
   }else{
    if(input.input !== null){
      url = "caseflowinitiation/getCaseDetailsByPetitionApproved?calculatePercentageFields=true&companyId="+input.input;
    }else if(input.param !== null){
      url = "caseflowinitiation/getCaseDetailsByPetitionApproved?calculatePercentageFields=true&filingUserName="+input.inputParam;
    }
    else if(input.input !== null && input.param !== null){
      url = "caseflowinitiation/getCaseDetailsByPetitionApproved?calculatePercentageFields=true&companyId="+input.input+"&filingUserName="+input.inputParam;
    }else if(input.input !== null && input.param !== null && input.lawfirmId !== null){
      url = "caseflowinitiation/getCaseDetailsByPetitionApproved?calculatePercentageFields=true&companyId="+input.input+"&filingUserName="+input.inputParam+"&lawfirmId="+input.inputParamlawfirmId;  
    }  else{
      url = "caseflowinitiation/getCaseDetailsByPetitionApproved?calculatePercentageFields=true";
    }  
   }
     if (input ==="") {
       return { data: [] };
     }
     let resultMethod;
     if(input.inputValue === "Cases"){
      resultMethod = HttpCase.axios()
      .get(url,  {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => { 

        return res;         
      })
      .catch((e: any) => {
        return e.response;
      });     
     }else{
      resultMethod = HttpCaseFlowInitiation.axios()
       .get(url,  {
         headers: {
           "Content-Type": "application/json",
           "Access-Control-Allow-Origin": "*",
         }
       })
       .then(res => { 

         return res;         
       })
       .catch((e: any) => {
         return e.response;
       });
      }
     return resultMethod;  
  }


  public static   createEmployeement  (input: any){
    var url = "api/createEmployeement";
    var obj=JSON.stringify(input.input);  

    if (input ==="") {
      return { data: [] };
    }
    const resultMethod = Http.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
       
        return res;
      }).catch((e: any) => {
      
        return e.response;
      });
    return resultMethod;
  }
  
  public static  updateEmployeement(input: any){
  var url = "api/updateEmployeement";
   
  var obj=JSON.stringify(input.input);   
  if (input ==="") {
    return { data: [] };
  }
  const resultMethod = Http.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
     
      return res;
    }).catch((e: any) => {
   
      return e.response;
    });
  return resultMethod;
  }

  public static  updateAllEmployeement(input: any){
    var url = "api/updateAllEmployeement";
  
    var obj=JSON.stringify(input.input);  
    
    if (input ==="") {
      return { data: [] };
    }
    const resultMethod = Http.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
       
        return res;
      }).catch((e: any) => {
     
        return e.response;
      });
    return resultMethod;
    }

    public static  getCaseflowsByPlanCompanyautoIdAndfilingUserName(input: any){
    //  var url = "caseflow/getCaseflowsByPlanCompanyautoIdAndfilingUserName/" + input.input;
      var url = "caseflow/getOrderDetailsWithPlanId/" + input.input;
     
        if (input ==="") {
          return { data: [] };
        }
    
        const resultMethod = HttpCase.axios()
          .get(url,  {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            }
          })
          .then(res => { 
            return res;
          })
          .catch((e: any) => {
            return e.response;
          });
        
        return resultMethod;  
    }
   }
 
